import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/berths`);
  },

  fetchDetail(portId, berthId) {
    return http.get(`${resource}/${portId}/berths/${berthId}`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/berths/${itemId}`, payload);
  },

  search(portId, payload) {
    return http.get(`${resource}/${portId}/berths/search`, { params: payload });
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/berths`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/berths/${itemId}`);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/berths/sorts`, payload);
  },
};
